import React from 'react';
import { t } from '../i18n';
import { pageTitle, type PageDef } from './pages';

/** Shown for a route whose page task is not built yet. */
export function PendingPage({ page }: { page: PageDef }) {
  return (
    <main className="bx-main">
      <div className="bx-ph">
        <div className="bx-ph-l">
          <h1 className="bx-h1">{pageTitle(page)}</h1>
          <p className="bx-ph-meta">
            <span className="bx-m">{page.id}</span>
            <span>{page.design}</span>
          </p>
        </div>
      </div>
      <section className="bx-panel">
        <div className="bx-state">
          <span className="bx-state-ic">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              aria-hidden="true"
            >
              <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM12 7v5l3 2" />
            </svg>
          </span>
          <span className="bx-state-t">{t('app.pending.title', 'This page is being built')}</span>
          <span className="bx-state-d">
            {t('app.pending.text', 'Its design is ready; the page will appear here when its frontend task is done.')}
          </span>
        </div>
      </section>
      <footer className="bx-foot">
        <span>
          <span className="bx-m">{page.id}</span> · {page.slug}
        </span>
      </footer>
    </main>
  );
}
